import { Component } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

//TODO SOON EXTENSION: merge with extension-core bar, it has been copied from there
@Component({
    selector: 'wecdev-left-bar-control',
    templateUrl: 'wecdev-left-bar.control.html',
    styleUrl: './wecdev-left-bar.control.scss',
    standalone: false,
})
export class WecdevLeftBarControl extends ControlBase {
    private leftControlBar: HTMLDivElement = null;

    private static LEFT_BAR_ID: string = 'wecdev-left-bar';
    private static LEFT_BAR_CLASS: string = 'wecdev-left-bar';

    private leftBarExists(): boolean {
        return this.leftControlBar !== null;
    }

    private createLeftBar(): void {
        if (this.leftBarExists()) {
            return;
        }
        let barDiv: HTMLDivElement = document.createElement('div');
        barDiv.className = WecdevLeftBarControl.LEFT_BAR_CLASS;
        barDiv.id = WecdevLeftBarControl.LEFT_BAR_ID;
        barDiv.setAttribute('tabindex', '0');
        let $devBarContainer = $('#wecdev-left-bar-container');
        $devBarContainer[0].appendChild(barDiv);
        this.leftControlBar = barDiv;
    }

    public showBar(): void {
        if (!this.leftBarExists()) {
            this.createLeftBar();
        }

        this.leftControlBar.focus();
    }

    public getLeftBarNode(): HTMLDivElement {
        return this.leftControlBar;
    }

    public addButton(buttonId: string, click: Function, caption?: string, customCssClass?: string): HTMLElement {
        if (!this.leftBarExists()) {
            this.createLeftBar();
        }
        let $button = $('#' + buttonId);
        //button already added we do nothing
        if (!this.ioc.core.utils.isNullOrEmpty($button)) {
            //return;
        }

        let button: HTMLButtonElement = document.createElement('button');
        button.id = buttonId;
        if (customCssClass) {
            button.className = customCssClass;
        }
        if (caption) {
            button.innerHTML = caption;
        }
        button.addEventListener('click', (e: Event): boolean => {
            click();
            return false;
        });

        this.leftControlBar.appendChild(button);
        return button;
    }

    public removeButton(buttonId: string): void {
        let $button = $('#' + buttonId);
        $button.remove();
    }
}
